export default "__VITE_ASSET__BklOge0A__"